/* eslint-disable react/no-danger */
import {processParams} from '@epic-core/common';

import ConfirmStage from '../../components/redeem/ConfirmStage';
import LoginRequired from '../../components/redeem/LoginRequired';
import PosaTemplate from '../../components/posa/PosaTemplate';
import PropTypes from 'prop-types';
import React from 'react';
import RedeemStore from '../../stores/RedeemStore';
import RedeemViewStyled from './RedeemViewStyled';
import {Redirect} from 'react-router';
import ValidateStage from '../../components/redeem/ValidateStage';
import {connectToStores} from 'epic-alt-utils';
import epicTracking from 'epic-tracking';
import queryString from 'query-string';
import {generateRouteTo} from '../../utils/route';
import GiftcardBox from '../../components/posa/GiftcardBox';
import CardCallout from '../../components/posa/CardCallout';

/**
 * RedeemView.
 *
 * Rendered when the Route matches /redeem
 */
@connectToStores
class RedeemView extends React.Component {
  static propTypes = {
    location: PropTypes.object,
    redeemStore: PropTypes.object,
    config: PropTypes.object,
    isLoggedIn: PropTypes.bool,
    loadScreen: PropTypes.node,
    altSuccessPath: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    content: PropTypes.string,
    enablePosa: PropTypes.bool,
    signInPosa: PropTypes.string,
    signOutPosa: PropTypes.string,
    posaData: PropTypes.object,
    posaLink: PropTypes.string,
    giftcardConfig: PropTypes.object,
  };

  static defaultProps = {
    title: '',
    description: '',
    content: '',
    enablePosa: false,
    signInPosa: '',
    signOutPosa: '',
  };

  static getStores() {
    return [RedeemStore];
  }

  static getPropsFromStores() {
    return {
      redeemStore: RedeemStore.getState(),
    };
  }

  componentDidUpdate(prevProps) {
    const {redeemStore} = this.props;
    const {currentStage} = redeemStore;
    const {redeemStore: prevRedeemStore} = prevProps;
    const {currentStage: prevCurrentState} = prevRedeemStore;
    if (currentStage === 'CONFIRM' && prevCurrentState !== 'CONFIRM') {
      epicTracking.trackEvent('Interaction', {
        interactionType: 'click',
        eventCategory: 'RedeemCode',
        eventAction: 'codeValidatedConfirmingUse',
      });
    }
  }

  render() {
    const {
      isLoggedIn,
      redeemStore,
      location,
      altSuccessPath,
      title,
      description,
      content,
      enablePosa,
      posaData,
      posaLink,
      giftcardConfig,
    } = this.props;
    const {posaGiftCardRedeemUrl, posaGiftCardCardShow} = giftcardConfig;
    const {currentStage} = redeemStore;
    const config = this.props.config || {};
    const code = location.search ? queryString.parse(location.search).code || '' : '';
    let redeemViewContent;

    if (redeemStore.currentStage === 'SUCCESS') {
      return altSuccessPath ? (
        <Redirect to={generateRouteTo(altSuccessPath, location)} />
      ) : (
        <div className="redeemView">
          <Redirect to={generateRouteTo('/redeem/confirmation', location)} />
        </div>
      );
    }
    if (!isLoggedIn || currentStage === 'LOGIN') {
      const loginParams = code ? `?${processParams({code})}` : '';
      const loginPath = `${location.pathname}${loginParams}`;
      redeemViewContent = <LoginRequired returnPath={loginPath} />;
    } else if (currentStage === 'VALIDATE') {
      redeemViewContent = (
        <ValidateStage
          redeemStore={redeemStore}
          prefillCode={code}
          config={config}
          enablePosa={enablePosa}
          posaLink={posaLink}
          posaImage={posaData.image}
          isLoggedIn={isLoggedIn}
          nextStage="CONFIRM"
          title={title}
          description={description}
        />
      );
    } else if (currentStage === 'CONFIRM') {
      redeemViewContent = (
        <ConfirmStage
          redeemStore={redeemStore}
          isLoggedIn={isLoggedIn}
          config={config}
          pageMapping="code-redeem"
          nextStage="SUCCESS"
        />
      );
    }
    return (
      <RedeemViewStyled className="redeemView">
        <div className={'redeem-content'}>
          {redeemViewContent}
          <div className="posa-callout-container">
            {enablePosa && posaData && (
              <CardCallout
                boxClass="vbucks-card"
                title={'epic.code.redemption.posa.vbucks.title'}
                redeemLink="/vbuckscard"
                imgSrc="https://cdn2.unrealengine.com/fn-vbuckscards-1b075ef6e2a5.svg"
                extra={
                  <PosaTemplate
                    Tag="div"
                    isTemplate
                    className="posa-help"
                    string={posaData.needHelp}
                  />
                }
              />
            )}
            {posaGiftCardCardShow && (
              <GiftcardBox showDesc={false} posaGiftCardRedeemUrl={posaGiftCardRedeemUrl} />
            )}
          </div>
          {content && isLoggedIn && (
            <PosaTemplate
              Tag="div"
              isTemplate
              className="site-block-content"
              dangerouslySetInnerHTML={{__html: content}}
            />
          )}
        </div>
        {this.props.redeemStore.loading ? this.props.loadScreen : null}
      </RedeemViewStyled>
    );
  }
}
export default RedeemView;
